__turbopack_context__.v({
  "bottom": "hero-module-scss-module__P_dh1q__bottom",
  "carousel": "hero-module-scss-module__P_dh1q__carousel",
  "content": "hero-module-scss-module__P_dh1q__content",
  "copy": "hero-module-scss-module__P_dh1q__copy",
  "default": "hero-module-scss-module__P_dh1q__default",
  "desktop_only": "hero-module-scss-module__P_dh1q__desktop_only",
  "extraCopy": "hero-module-scss-module__P_dh1q__extraCopy",
  "full_width": "hero-module-scss-module__P_dh1q__full_width",
  "h1": "hero-module-scss-module__P_dh1q__h1",
  "h2asp": "hero-module-scss-module__P_dh1q__h2asp",
  "highlights_hero": "hero-module-scss-module__P_dh1q__highlights_hero",
  "homepage": "hero-module-scss-module__P_dh1q__homepage",
  "image": "hero-module-scss-module__P_dh1q__image",
  "imageDesktop": "hero-module-scss-module__P_dh1q__imageDesktop",
  "imageMobile": "hero-module-scss-module__P_dh1q__imageMobile",
  "image_desktop": "hero-module-scss-module__P_dh1q__image_desktop",
  "image_fallback": "hero-module-scss-module__P_dh1q__image_fallback",
  "image_mobile": "hero-module-scss-module__P_dh1q__image_mobile",
  "image_only": "hero-module-scss-module__P_dh1q__image_only",
  "image_wrapper": "hero-module-scss-module__P_dh1q__image_wrapper",
  "left": "hero-module-scss-module__P_dh1q__left",
  "left_content": "hero-module-scss-module__P_dh1q__left_content",
  "left_title": "hero-module-scss-module__P_dh1q__left_title",
  "linkLabel": "hero-module-scss-module__P_dh1q__linkLabel",
  "main": "hero-module-scss-module__P_dh1q__main",
  "media_wrapper": "hero-module-scss-module__P_dh1q__media_wrapper",
  "mobile_only": "hero-module-scss-module__P_dh1q__mobile_only",
  "over": "hero-module-scss-module__P_dh1q__over",
  "right": "hero-module-scss-module__P_dh1q__right",
  "slide": "hero-module-scss-module__P_dh1q__slide",
  "slideMedia": "hero-module-scss-module__P_dh1q__slideMedia",
  "story_hero": "hero-module-scss-module__P_dh1q__story_hero",
  "subtitle": "hero-module-scss-module__P_dh1q__subtitle",
  "swiper": "hero-module-scss-module__P_dh1q__swiper",
  "tag": "hero-module-scss-module__P_dh1q__tag",
  "title": "hero-module-scss-module__P_dh1q__title",
  "top": "hero-module-scss-module__P_dh1q__top",
  "top_content": "hero-module-scss-module__P_dh1q__top_content",
  "top_title": "hero-module-scss-module__P_dh1q__top_title",
});
